@import (reference) '../../../constants/spacing.module.less';

// declared here but targeting the div that wraps the group
// that div lives in 'shipping-service-selector'
.service-collection-group > div:has(.group-label),
.rate-shopper-group-header {
  background: var(--purple-F6F2FF);
}

.group-with-help {
  justify-content: space-between;
}

.group-label {
  gap: @space-8;
  align-items: center;
}

.info-icon {
  display: flex;
  align-items: center;
}

.button-row {
  margin-right: @space-8;
}

.manage-button {
  display: flex;
  align-items: center;
  gap: @space-4;
  white-space: nowrap;

  > svg {
    height: 14px;
    width: 14px;
  }
}
